const classes = {
  bannerContainer:
    'flex items-center mt-2 mb-8 gap-2 p-3 rounded bg-[#FDEDED] border border-[#B00020]',
  bannerContainerWarning:
    'flex items-center mt-2 mb-8 gap-2 p-3 rounded bg-[#FFF4E5] border border-[#ED6C02]',
  bannerTitle: 'flex items-center gap-2 text-[#B00020] font-semibold text-sm',
  bannerTitleWarning:
    'flex items-center gap-2 text-[#663C00] font-semibold text-sm',
  bannerBody: 'text-xs text-[#333333]',
  bannerInfo: 'text-xs text-[#000]',
  requestCreditButton: 'bg-white! ',
  bannerActionsContainer: 'flex items-center justify-end mt-2',
};

export default classes;
